import React, { useState } from 'react';
import { IAppProps } from '@interfaces/App.interface';
import { Grid, Typography } from '@ts/storybook';
import KPI from '@components/KPI';
import { appPalette } from '@public/customization/CustomTheme';

interface DashboardProps extends IAppProps {}

const DashboardMockPage = (props: DashboardProps) => {
  const [value, setValue] = useState('today');
  const [slot, setSlot] = useState('week');

  const firstColor = appPalette.primary;
  const lastColor = '#077bc0';

  //#region Handlers
  const onChangeSlot = (item: any, type: string) => {
    setSlot(type);
  };
  //#endregion

  //#region MockData
  const data1 = {
    xaxis: {
      categories: ['Trolley-Luggage', 'Trolley-Compact', 'Cart Shopper', 'WheelChair', 'Vehicles', 'Cleaning cart'],
    },
    series: [
      {
        name: 'Items tracked',
        data: [73, 4, 146, 255, 20, 10],
      },
    ],
  };
  const data2 = {
    xaxis: {
      categories: ['Staff', 'Cleaners', 'Security', 'Passengers', 'Others'],
    },
    series: [
      {
        name: 'PERSONNEL ON SITE BY CATEGORY',
        data: [8, 4, 6, 230, 45],
      },
    ],
  };

  const data3 = {
    xaxis: {
      categories: ['Forbidden area', 'Low stock', 'Abandoned', 'Out of perimeter', 'In reparation'],
    },
    series: [
      {
        name: 'HSE Events',
        data: [30, 40, 260, 50, 120],
      },
    ],
  };

  //#endregion

  return (
    <Grid container size={12} spacing={3} p={4}>
      {/* row 1 */}
      {/* <Grid size={{ xs: 12 }} sx={{ mb: -2.25 }}>
        <Typography variant="h5">Dashboard</Typography>
      </Grid> */}
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Trolleys stored" dataCard={{ value: 2356, oldValue: 970 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Collected trolleys" dataCard={{ value: 6823, oldValue: 6000 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Warnings open" dataCard={{ value: 21, oldValue: 32 }} />
      </Grid>
      <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
        <KPI.KPICard title="Notifications in 24h" dataCard={{ value: 5, oldValue: 5 }} />
      </Grid>

      {/* row 2 */}
      <Grid size={{ xs: 12, sm: 6, md: 4 }}>
        <KPI.PieChart
          {...props}
          title={'Warnings by severity'}
          dataChart={{
            labels: [],
            series: [{ name: 'string', data: [] }],
          }}
          loading={false}
          isMock
        />
      </Grid>
      <Grid size={{ xs: 12, md: 8 }}>
        <KPI.BarChart {...props} options={{ color: '#ff0003', title: 'Trolley events' }} dataChart={data3} loading={false} />
      </Grid>

      {/* row 3 */}
      <Grid size={{ xs: 12, md: 6 }} sx={{ paddingTop: 0 }}>
        <KPI.BarChart {...props} options={{ color: '#0a8103', title: 'Items tracked' }} dataChart={data1} loading={false} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }} sx={{ paddingTop: 0 }}>
        <KPI.BarChart {...props} options={{ color: '#0000ff', title: 'Persons tracked' }} dataChart={data2} loading={false} />
      </Grid>

      {/* row 4 */}
      <Grid size={{ xs: 12 }}>
        <KPI.MainCard content={false} sx={{ pt: 2 }}>
          <Grid size={{ xs: 12 }} ml={2}>
            <Typography variant="h5" fontWeight={'500'} color="primary" text="Trolleys in zones" />
          </Grid>
          <Grid size={{ xs: 12 }} style={{ padding: '18px' }}>
            <KPI.StackedBarChart type={2} />
          </Grid>
        </KPI.MainCard>
      </Grid>

      {/* row 5 */}
      <Grid size={{ xs: 12 }}>
        <KPI.ColumnsWithMarkersChart {...props} title={'Trolley stock in collection points​'} type={1} loading={false} />
      </Grid>
    </Grid>
  );
};

export default DashboardMockPage;
